
import React from 'react';
import { motion } from 'framer-motion';

interface ClubAboutTabProps {
  description: string;
}

const ClubAboutTab: React.FC<ClubAboutTabProps> = ({ description }) => {
  return (
    <motion.div 
      className="prose prose-sm max-w-none"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        className="text-foreground/90 leading-relaxed"
      >
        {description}
      </motion.p>
    </motion.div>
  );
};

export default ClubAboutTab;
